import PriceBreakdownDetails from 'components/park/detail/PriceBreakdownDetails';
import {
  formatServiceFeeConfigToTextWithCurrency,
  getPricesWithCurrency,
} from 'components/park/detail/PriceBreakdownDetailsHelper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParkzoneStore } from 'stores/parkzoneStore';
import { Maybe, ParkingSession } from 'types/generatedSchemaTypes';

export type OngoingParkingSessionPriceBreakdownType = {
  session: Maybe<ParkingSession> | undefined;
};

const OngoingParkingSessionPriceBreakdownDetails = () => {
  const { t } = useTranslation();
  const ongoingSessionPriceBreakdown = useParkzoneStore(
    (state) => state.ongoingParkingSessionPriceBreakdownValues
  );
  const ongoingSession = ongoingSessionPriceBreakdown?.session;
  const countryCode = ongoingSession?.countryCode;
  const hasCorporateAccount =
    ongoingSession?.paymentType === 'CORPORATE_ACCOUNT';

  const {
    percent: serviceFeePercent,
    min: serviceFeeMin,
    max: serviceFeeMax,
    showServiceFeePercentInfo,
  } = formatServiceFeeConfigToTextWithCurrency(
    ongoingSession?.priceConfig?.serviceFee,
    countryCode,
    hasCorporateAccount
  );

  const { totalPrice, serviceFee, parkingFee } = getPricesWithCurrency({
    totalAmount: ongoingSession?.price?.totalAmount,
    serviceFee: ongoingSession?.price?.breakdown?.serviceFee?.amount,
    parkingFee: ongoingSession?.price?.breakdown?.parkingFee?.amount,
    parkingZoneCountryCode: ongoingSession?.countryCode,
  });

  return (
    <PriceBreakdownDetails
      parkingFee={parkingFee ?? t('price.noPrice')}
      serviceFee={serviceFee ?? t('price.noPrice')}
      totalPrice={totalPrice ?? t('price.noPrice')}
      serviceFeePercent={serviceFeePercent}
      serviceFeeMin={serviceFeeMin}
      serviceFeeMax={serviceFeeMax}
      showServiceFeePercentInfo={showServiceFeePercentInfo}
      hasCorporateAccount={hasCorporateAccount}
    />
  );
};

export default OngoingParkingSessionPriceBreakdownDetails;
